import React, { Component } from 'react'
import Header from '../components/Header'
import { virtualPush } from '../analytics'
import { interstitial } from '../ads'
import { scroller } from 'react-scroll'
import IntroSection from '../containers/IntroSection'
import TimelineSection from '../containers/TimelineSection'
import ArticleSection from '../containers/ArticleSection'
import AmpSection from '../containers/AmpSection'
import PedalSection from '../containers/PedalSection'
import throttle from 'lodash.throttle'
import navItems from '../data/nav-items.json'

class Index extends Component {
    constructor() {
        super();
        this.toggleMobile = this.toggleMobile.bind(this);
        this.throttleToggleMobile = throttle(this.toggleMobile, 600);
        this.state = {};
    }
    componentDidMount() {
        this.toggleMobile();
        virtualPush('', 'טונים צורמים');
        interstitial();
        const initialSection = this.props.match.params.section;
        if (initialSection) {
            let offset = -100;
            const sectionData = navItems.find(item => item.target === initialSection);
            setTimeout(() => {
                if (sectionData && sectionData.offset && sectionData.mobOffset)
                    offset = sectionData[this.state.isMobile ? 'mobOffset' : 'offset'];
                scroller.scrollTo(initialSection, {
                    duration: 1000,
                    smooth: true,
                    offset
                });
            }, 800)
        }

        window.addEventListener('resize', this.throttleToggleMobile, false);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.throttleToggleMobile, false);
    }
    toggleMobile() {
        this.setState({
            isMobile: window.document.body.clientWidth <= 980
        });
    }
    render() {
        return (
            <div>
                <Header isMobile={this.state.isMobile} />
                <IntroSection isMobile={this.state.isMobile} />
                <AmpSection />
                <TimelineSection isMobile={this.state.isMobile} />
                <PedalSection isMobile={this.state.isMobile} />
                <ArticleSection />
            </div>
        )
    }
}

export default Index;


// WEBPACK FOOTER //
// ./src/pages/Index.jsx